import { useTranslation } from "react-i18next";

import { SecondaryButton } from "@shared/CustomButton";

export const ClosePanelButton = ({ onClick }: { onClick: () => void }) => {
    const { t } = useTranslation(["common"]);

    return (
        <SecondaryButton onClick={onClick} tooltipProps={{ title: t("common:button.close") }}>
            <i className="fa-solid fa-xmark" />
        </SecondaryButton>
    );
};
